import { AffiliateCreate } from 'features/AffiliateCreate';

const AffiliateCreatePage = (): JSX.Element => {
	return <AffiliateCreate />;
};

export default AffiliateCreatePage;
